module.exports = __webpack_public_path__ + "static/media/processing.e9353cba.png";